
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import ChangePasswordPage from './pages/ChangePasswordPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import AdminLoginPage from './pages/AdminLoginPage';
import ProtectedRoute from './components/ProtectedRoute';
import JobDetailsPage from './pages/JobDetailsPage';
import { ConfigProvider } from './context/ConfigContext';
import { AdminViewProvider } from './context/AdminViewContext';
import './firebase';

function App() {
  const isDevEnvironment = process.env.REACT_APP_FIREBASE_PROJECT_ID === 'loope-dev-env';

  return (
    <AdminViewProvider>
      <Router>
        <div className="min-h-screen bg-sky-100">
          {isDevEnvironment && (
            <div className="bg-yellow-500 text-white text-center py-1 px-4 text-sm font-medium sticky top-0 z-50 shadow-md">
              🧪 TEST ENVIRONMENT - Development Mode
            </div>
          )}
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/admin-login" element={<AdminLoginPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route 
              path="/change-password" 
              element={
                <ProtectedRoute>
                  <ChangePasswordPage />
                </ProtectedRoute>
              } 
            />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <ConfigProvider>
                    <Home />
                  </ConfigProvider>
                </ProtectedRoute>
              }
            />
            <Route
              path="/job/:jobId"
              element={
                <ProtectedRoute>
                  <ConfigProvider>
                    <JobDetailsPage />
                  </ConfigProvider>
                </ProtectedRoute>
              }
            />
          </Routes>
        </div>
      </Router>
    </AdminViewProvider>
  );
}

export default App;
